import React, { useState } from "react";
import { useQuery } from "react-query";
import { fetchRace } from "@Services/api";
import qs from "qs";

const Barrage: React.FC<any> = ({ styles, styleItem, type = "installment" }) => {
  const [visible, setVisible] = useState<boolean>(true);
  let { kindType } = qs.parse(location.search, { ignoreQueryPrefix: true });
  const { data } = useQuery(
    [`fetchRace`, kindType],
    async () => {
      const res = await fetchRace({ type: type });

      if (res?.status === 12000) {
        const copiedArray = Array(120)
          .fill()
          .flatMap(() => res.data.list); // 复制20次
        setTimeout(() => {
          setVisible(false);
        }, 1000);
        return copiedArray;
      }
    },
    { initialData: [] },
  );

  return (
    <div id='Barrage' className='flex w-full h-50 relative overflow-hidden' style={styles}>
      {Array.isArray(data) && data.length > 0 && (
        <div
          className={`absolute top-2 left-0  rounded-full w-full h-48 flex items-center`}
          style={{ transition: `left 400s linear`, left: visible ? 0 : "-20000px" }}
        >
          <div className='relative flex'>
            {data?.map((item, index) => (
              <div
                className='px-10 bg-[#F5F5F5] py-6 mr-30 text-black text-12 font-normal whitespace-pre rounded-full'
                key={index.toString(36)}
                style={styleItem}
              >
                {item}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
export default Barrage;
